import { render, staticRenderFns } from "./product-system.vue?vue&type=template&id=8d311ab2&scoped=true"
import script from "./product-system.vue?vue&type=script&lang=js"
export * from "./product-system.vue?vue&type=script&lang=js"
import style0 from "./product-system.vue?vue&type=style&index=0&id=8d311ab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d311ab2",
  null
  
)

export default component.exports